<template>
  <div
    ref="tabbar"
    class="emd-tabbar jsTabbar _bordered eu-mt_3 _bordered"
  >
    <ul class="emd-tabbar__list">
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === null }"
          @click="selectItem(null)"
        >
          <span class="emd-text">{{ $t('payment-method.all') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'credit_card' }"
          @click="selectItem('credit_card')"
        >
          <i class="eu-mr_1 uil uil-credit-card" />
          <span class="emd-text">{{ $t('payment-method.credit-card') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'debit_card' }"
          @click="selectItem('debit_card')"
        >
          <i class="eu-mr_1 uil uil-card-atm" />
          <span class="emd-text">{{ $t('payment-method.debit') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'boleto' }"
          @click="selectItem('boleto')"
        >
          <i class="eu-mr_1 uil uil-invoice" />
          <span class="emd-text">{{ $t('payment-method.boleto') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'voucher' }"
          @click="selectItem('voucher')"
        >
          <i class="eu-mr_1 uil uil-ticket" />
          <span class="emd-text">{{ $t('payment-method.voucher') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          :data-active="isPix"
          href="javascript:void(0);"
          class="tab-item"
          @click="selectItem('pix')"
        >
          <emerald-icon
            icon="pix-outline"
            class="eu-mr_1"
            style="max-width: unset; height: 16px"
          />
          <span class="emd-text">{{ $t('payment-method.pix') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'bank_transfer' }"
          @click="selectItem('bank_transfer')"
        >
          <i class="eu-mr_1 uil uil-exchange" />
          <span class="emd-text">{{ $t('payment-method.bank-transfer') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'safetypay' }"
          @click="selectItem('safetypay')"
        >
          <i class="eu-mr_1 uil uil-play-circle" />
          <span class="emd-text">{{ $t('payment-method.safety-pay') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'private_label' }"
          @click="selectItem('private_label')"
        >
          <i class="eu-mr_1 uil uil-tag-alt" />
          <span class="emd-text">{{ $t('payment-method.private-label') }}</span>
        </a>
      </li>
      <li class="emd-tabbar__item">
        <a
          href="javascript:void(0);"
          class="emd-tabbar__link"
          :class="{ _active: paymentMethod === 'cash' }"
          @click="selectItem('cash')"
        >
          <i class="eu-mr_1 uil uil-money-bill" />
          <span class="emd-text">{{ $t('payment-method.cash') }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { EmeraldIcon } from 'emerald-vue/src/components'
import { isPix } from '@/enums/payment-method.enum'
export default {
  name: 'TabbarPaymentMethod',
  components: { EmeraldIcon },
  props: ['paymentMethod'],
  computed: {
    isPix () {
      return this.paymentMethod !== null && isPix(this.paymentMethod)
    }
  },
  mounted () {
    const $tabbar = this.$refs.tabbar
    let startX
    let scrollLeft
    let isDown = false
    $tabbar.addEventListener('mousewheel', function (e) {
      e.preventDefault()
      $tabbar.scrollLeft += e.deltaY
    })

    $tabbar.addEventListener('mousedown', function (e) {
      e.preventDefault()
      isDown = true
      startX = e.pageX - $tabbar.offsetLeft
      scrollLeft = $tabbar.scrollLeft
    })

    $tabbar.addEventListener('mousemove', function (e) {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - $tabbar.offsetLeft
      const walk = (x - startX) * 2
      $tabbar.scrollLeft = scrollLeft - walk
    })

    $tabbar.addEventListener('mouseup', function (e) {
      e.preventDefault()
      isDown = false
    })

    $tabbar.addEventListener('touchstart', function (e) {
      isDown = true
      if (e.touches.length > 0) {
        startX = e.touches[0].pageX - $tabbar.offsetLeft
      } else {
        startX = e.pageX - $tabbar.offsetLeft
      }
      scrollLeft = $tabbar.scrollLeft
    })

    $tabbar.addEventListener('touchmove', function (e) {
      e.preventDefault()
      if (!isDown) return
      let x
      if (e.touches.length > 0) {
        x = e.touches[0].pageX - $tabbar.offsetLeft
      } else {
        x = e.pageX - $tabbar.offsetLeft
      }
      const walk = (x - startX) * 2
      $tabbar.scrollLeft = scrollLeft - walk
    })

    $tabbar.addEventListener('touchend', function (e) {
      isDown = false
    })
  },
  methods: {
    selectItem (item) {
      this.$emit('paymentSelected', item)
    }
  }
}
</script>
<style scoped>
.tab-item {
  @apply flex flex-row justify-center pt-2 pb-3 hover:border-[#30A46C] border-b data-[active]:border-[#30A46C];
}
</style>
